//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectBodyList.js";
import "../no/ScCollector.js";
import "../no/SelectBody.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"ActionType",1,0],[1,"TargetBodies",0,"SelectBodyList",0],[0,"TargetSelectScope",1,0],[1,"ToolFace",0,"ScCollector",0],[1,"ToolSheetBody",0,"SelectBody",0],[0,"TrimDirection",1,0],[0,"TrimPart",1,0],[0,"TrimSurface",1,0]],[[["surfaceType","trimDirection","targets","tools"],"SetTrimDataDetails",{},4,0]],[]];
SPLM.Tooling.TrimMoldComponentsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.TrimMoldComponentsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.TrimMoldComponentsBuilder.TrimMethod = Object.freeze({
    "Trim" : "Trim", "Untrim" : "Untrim"});

SPLM.Tooling.TrimMoldComponentsBuilder.TrimPartName = Object.freeze({
    "Notrimpart" : "Notrimpart"});

SPLM.Tooling.TrimMoldComponentsBuilder.TrimSurfaceName = Object.freeze({
    "SelectFaces" : "SelectFaces", "SelectSheetBody" : "SelectSheetBody"});

SPLM.Tooling.TrimMoldComponentsBuilder.TargetScope = Object.freeze({
    "Product" : "Product", "Any" : "Any"});

export default SPLM;